import { MessageBox } from 'element-ui'

/**
 * 公用确认信息提示窗
 * @export
 * @author Hanger Zou
 * @param  {string} [text='确定执行此操作吗'] 弹框提示文字
 * @param  {string} [type='warning'] 弹框提示类型
 * @returns {Promise<MessageBoxData>}
 */
export function handleCofirm(text = '确定执行此操作吗？', type = 'warning') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: type,
    center: false
  })
}
/**
 * 公用消息提示窗
 * @export
 * @author Hanger Zou
 * @param  {string} [text='确定执行此操作吗'] 弹框提示文字
 * @param  {string} [type='warning'] 弹框提示类型
 * @returns {Promise<MessageBoxData>}
 */
export function handleAlert(text = '确定执行此操作吗？', type = 'warning') {
  return MessageBox.alert(text, '提示', {
    confirmButtonText: '确定',
    type: type,
    center: false
  })
}

/**
 * 公用消息通知
 * @author Hanger Zou
 * @export
 * @param {string} [type='info'] 消息提示类型
 * @param {string} [msg='提示'] 消息提示内容
 * @param {boolean} [showClose=true] 消息提示是否可关闭
 */
export function handleMessage(type = 'info', msg = '提示', showClose = true) {
  this.$message({
    showClose: showClose,
    type: type,
    message: msg
  })
}
